import { useState } from 'react';
import { classNames } from '@/lib/format';
import { useActiveAnnouncements } from '@/api/hooks/useAnnouncements';
import { useAuth } from '@/features/auth/AuthProvider';

export function AnnouncementBanner() {
  const { user } = useAuth();
  const { data } = useActiveAnnouncements(!!user);
  const [dismissed, setDismissed] = useState(false);
  const active = data?.[0];
  if (!active || dismissed) return null;
  return (
    <div className={classNames('banner', active.level === 'warning' && 'banner--warning')}>
      <strong>Notice:</strong> <span>{active.body}</span>
      <button className="banner__close" onClick={() => setDismissed(true)} aria-label="Dismiss">
        ✕
      </button>
    </div>
  );
}
